/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Modal, Pagination, CustomLoading, Breadcrumb, SelectEquipment, Input, Label } from "../../../Components";

/* 🔗 SERVICE */
import { LogServices } from "../../../Services/logServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { changeModal } from "../../../Redux/Actions";


/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, HeaderContainer, 
    ContainerHead, CardsContainer, Card, ContainerSelect } from "./styles";

import { isValidStartData, isValidEndData } from "../../../util/validate.js";

const IPCLogsList = () => {
    const { t } = useTranslation();

    document.title = t("ipclogs.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/IPClogs' },
        { text: 'ipclogs', page: '/adm/IPClogs' }
    ]

    const Services = useRef(new LogServices());
    
    const [logs, setLogs] = useState([]);
    const [log, setLog] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingLog, setIsLoadingLog] = useState(true);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState("");
    const [equipaments, setEquipaments] = useState([]);
    const [selectedEquipament, setSelectedEquipament] = useState("");
    const AllEquipaments = useRef([]);
    const [selectedLevel, setSelectedLevel] = useState("");
    const [datainicio, setDatainicio] = useState("");
    const [datafim, setDatafim] = useState("");

    const getLogs = async() => {
        let currentitem = await Services.current.getAllEquipmentsLogs();
        setLogs(currentitem);
        setIsLoading(false);
    }

    useEffect(() => {
        async function getEquipaments() {
            const currentitem = await Services.current.getAllEquipments();
            setEquipaments([{name: "Selecionar equipamento", id: ""}, ...currentitem]);
            AllEquipaments.current = currentitem;
        }

        async function getcities() {
            const currentitem = await Services.current.getAllCities();
            setCities([{name: "Selecionar cidade", id: ""}, ...currentitem]);
        }

        getLogs();
        getcities();
        getEquipaments();
    }, []);

    const aplyFilter = async(id_equipment, level, start_date, end_date) => {
        setIsLoading(true);
        const currentitem = await Services.current.getAllEquipmentsLogs(id_equipment, level, start_date, end_date, 1);
        setLogs(currentitem);
        setIsLoading(false);
    }

    const changePage = async(page) => {
        setIsLoading(true);
        let currentitem = await Services.current.getAllEquipmentsLogs(selectedEquipament, selectedLevel, datainicio, datafim, page);
        setLogs(currentitem);
        setIsLoading(false);
    }

    const getLog = async(logid) => {
        setIsLoadingLog(true);
        store.dispatch(changeModal('logItem'));
        let currentitem = await Services.current.getEquipmentLog(logid);
        // console.log(currentitem);
        setLog(currentitem);
        setIsLoadingLog(false);
    }

    // Formata a data com base no idioma
    const formatDate = (value) => {
        const dateObj = new Date(value);
        return t("date.date-hour", {date: new Date(dateObj), format: "dateAndHour"});
    }

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("ipclogs.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <ContainerSelect>
                        <SelectEquipment Color={'white'} options={cities} value={selectedCity} onChange={(e) => {
                            if(e.target.value === "Selecionar cidade") {
                                setSelectedCity("");
                                setEquipaments([{name: "Selecionar equipamento", id: ""}, ...AllEquipaments.current]);
                                return;
                            }
                            setSelectedCity(e.target.value);
                            const equipamentsFiltered = AllEquipaments.current.filter((item) => parseInt(item.city.code_ibge) === parseInt(e.target.value));
                            setEquipaments([ {name: "Selecionar equipamento", id: ""}, ...equipamentsFiltered ]);
                        }} />

                        <SelectEquipment options={equipaments} value={selectedEquipament} onChange={(e) => {
                            if(e.target.value === "Selecionar equipamento"){
                                setSelectedEquipament("");
                            }else{
                                setSelectedEquipament(e.target.value);
                            }
                        }}/>

                        <SelectEquipment options={[
                            {name: "Selecionar nível", id: ""},
                            {name: "Aviso", id: "warning"},
                            {name: "Error", id: "error"},
                            {name: "Critico", id: "critical"},
                        ]} value={selectedLevel} onChange={(e) => {setSelectedLevel(e.target.value)}}/>
                    </ContainerSelect>

                    {/* <Button width={'fit-content'} text={t("buttons.apply")} color={'green'} onClick={() => aplyFilter(selectedEquipament, selectedLevel)}></Button> */}
                </HeaderContainer>

                <HeaderContainer>
                    <ContainerSelect>
                        <div>
                            <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='datainicio' 
                                name='datainicio' 
                                type="datetime-local" 
                                placeholder={t("inputs.initial-date.placeholder")}
                                value={datainicio}
                                max={datafim}
                                // innerRef={UserField}
                                invalidMessage={t("inputs.initial-date.invalid-message")}
                                validationFunction={(text) => isValidStartData(text, datafim)}
                                onchange={(text) => text && setDatainicio(text)}> 
                            </Input>
                        </div>
                        <div>
                            <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='datafim' 
                                name='datafim' 
                                type="datetime-local" 
                                placeholder={t("inputs.final-date.placeholder")}
                                value={datafim}
                                min={datainicio}
                                invalidMessage={t("inputs.final-date.invalid-message")}
                                validationFunction={(text) => isValidEndData(datainicio, text)}
                                onchange={(text) => (text && !isNaN(new Date(text).getTime())) && setDatafim(text)}> 
                            </Input>
                        </div>
                    </ContainerSelect>

                    <Button width={'fit-content'} text={t("buttons.apply")} color={'green'} onClick={() => aplyFilter(selectedEquipament, selectedLevel, datainicio, datafim)}></Button>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + logs?.total + " " + t("administrative.sub-items.logs.logs") }
                    </CountContainer>
                </ContainerHead>
                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.equipment") }</TitleText>
                        <TitleText>{t("header-table.date")}</TitleText>
                        <TitleText>{t("header-table.level")}</TitleText>
                    </LineTitle>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        logs?.data?.map((item) => (
                            
                            <LineList key={item.id} onClick={() => getLog(item.id)}>
                                <ListText>{item?.equipment}</ListText>
                                <ListText>{formatDate(item?.created_at)}</ListText>
                                <ListText>{item?.level}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>

                <Pagination last_page={logs?.last_page} currentpage={logs?.current_page} changepage={changePage}/>
            </Container>

            <Modal title={t("modal.logItem.title")} name={'logItem'} width={'50%'} height={'75%'}>
                {isLoadingLog ?
                    <CustomLoading width={'150px'} height={'150px'}/>
                    :
                    <CardsContainer>
                        <Card>
                            <div className="profile-view__card">
                                <div className="profile-view__info">
                                    <span className="profile-view__date">{formatDate(log?.created_at)}</span>
                                    <span className="profile-view__company">{log?.equipment?.name}</span>
                                </div>

                                {log?.message && Object.entries(log?.message).map(([key, value]) => {
                                    if(typeof value !== "string"){
                                        return (<></>)
                                    }
                                    return (
                                        <div key={key} className="profile-view__message">
                                            <p className="profile-view__description">
                                                <span className="profile-view__key">
                                                    {t(`ipclogs.${key}`, { defaultValue: key })}: {value}
                                                </span>
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                        </Card>
                    </CardsContainer>   
                }
            </Modal>
        </>
    )
}

export default IPCLogsList;
